// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1216":"22c8c2909f8f40e4","2888":"de29996d010588cd"}[chunkId] + ".css";
};